module.exports = __webpack_public_path__ + "static/media/Logo_Rasmi_UMT.7cd47fdf.png";